import { transitionAgentModalForm } from '../../../actions/motorPrivateRW/motorAgentModal';
import { getAgentForm } from '../../../selectors/motorPrivateRW/travelAgentModal';

import { FIELD_STATUS } from '../../../reducers/status';

export const agentModaleFormRules = (store, next, action) => {
    const result = next(action);
    const healthInsuranceAgentModalForm = getAgentForm(store.getState());
    const agentModalForm = validateAgentModalForm(healthInsuranceAgentModalForm);
    const formAction = agentModalForm
        ? transitionAgentModalForm.formValid()
        : transitionAgentModalForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateAgentModalForm = formFields => {
    return (
        formFields.name &&
        formFields.name.status === FIELD_STATUS.VALID &&
        formFields.agentCode &&
        formFields.agentCode.status === FIELD_STATUS.VALID
    );
};